import Swal, { SweetAlertResult } from 'sweetalert2'
import { clearInputError, Message } from '../_metronic/helpers'
import { api } from '../api/APIMiddlewares'
import { getActiveUsers, getTeamMembers, getRoles } from '../api/AdminAPI'
import { DELETE_MESSAGE, UPDATE_MESSAGE } from '../utils/contants'
import { AlertProps } from './data/AlertDefaults'
import { setupAxios } from './modules/auth'

import {
  APIResponse,
  CommonApiDataType,
  InputErrorType,
  SelectValueType,
  SubmitAPIStatusType,
} from './types/OtherTypes'
import { getDesignations } from '../api/DesignationAPI'
import { getEmploymentTypes } from '../api/EmploymentType'
import { getLeaveTypes } from '../api/ConfigurationAPI'

export const getUserData = (setUser: Function) => {
  getActiveUsers().then((res: APIResponse) => {
    if (res.statusCode === 200) {
      let users: SelectValueType[] = []
      res?.data?.map((obj: any) => {
        users.push({
          label: `${obj?.firstName ?? ''} ${obj?.lastName ?? ''}`,
          value: obj.id,
        })
      })
      setUser(users)
    }
  })
}

export const getTeamMemberData = (setUser: Function, id: string) => {
  getTeamMembers(id).then((res: APIResponse) => {
    if (res.statusCode === 200) {
      let users: SelectValueType[] = []
      let usersWithoutEmployeeCode = 0

      res?.data?.map((obj: any) => {
        // IMPROVED FIX: Prefer employee codes, but allow fallback to prevent "No options"
        const fullName = `${obj?.firstName ?? ''} ${obj?.lastName ?? ''}`.trim()

        if (obj.employeeCode && obj.employeeCode.trim()) {
          // User has employee code - show name as label, use employee code as value
          users.push({
            label: fullName || obj.employeeCode, // Show name, fallback to employee code if no name
            value: obj.employeeCode,
          })
        } else {
          // User doesn't have employee code - use ID with clear label
          usersWithoutEmployeeCode++
          const fullName = `${obj?.firstName ?? ''} ${obj?.lastName ?? ''}`.trim()
          users.push({
            label: `${fullName} (No Employee Code)`,
            value: obj.id, // Fallback to ID
          })
        }
      })

      // Log warning if some users don't have employee codes
      if (usersWithoutEmployeeCode > 0) {
        console.warn(`[AMS] ${usersWithoutEmployeeCode} user(s) don't have employee codes. Please assign employee codes to prevent audit log issues.`)
      }

      setUser(users)
    }
  })
}

export const getDesignationData = (setDesignation: Function) => {
  getDesignations().then((res: APIResponse) => {
    if (res.statusCode === 200) {
      let designation: SelectValueType[] = []
      res?.data?.map((obj: any) => {
        designation.push({
          label: obj?.name,
          value: obj?.id,
        })
      })
      setDesignation(designation)
    }
  })
}

export const getEmploymentTypeData = (setEmploymentTypes: Function) => {
  getEmploymentTypes().then((res: APIResponse) => {
    if (res.statusCode === 200) {
      let employmentType: SelectValueType[] = []
      res?.data?.map((obj: any) => {
        employmentType.push({
          label: obj?.name + '-' + obj.duration + ' Months',
          value: obj?.id,
        })
      })
      setEmploymentTypes(employmentType)
    }
  })
}

export const getLeaveTypeData = (setLeaveTypes: Function) => {
  getLeaveTypes().then((res: APIResponse) => {
    if (res.statusCode === 200) {
      let leaveType: SelectValueType[] = []
      res?.data?.map((obj: any) => {
        leaveType.push({
          label: obj?.name,
          value: obj?.id,
        })
      })
      setLeaveTypes(leaveType)
    } else {
      // Handle API errors when loading leave types
      console.error('Failed to load leave types:', res)
      setLeaveTypes([]) // Set empty array to prevent undefined errors
    }
  }).catch((error) => {
    // Handle network errors when loading leave types
    console.error('Network error loading leave types:', error)
    setLeaveTypes([]) // Set empty array to prevent undefined errors
  })
}

export const getRoleData = (setRoles: Function) => {
  const { token, tenantId } = setupAxios()
  // Use the correct roles endpoint
  api.get('/roles', token, tenantId, false).then((res: APIResponse) => {
    if (res.statusCode === 200) {
      let roles: SelectValueType[] = []
      res?.data?.map((obj: any) => {
        roles.push({
          label: obj?.name,
          value: obj?.id,
        })
      })
      setRoles(roles)
    }
  })
}

export const getReportingManagerData = (setManagers: Function) => {
  getActiveUsers().then((res: APIResponse) => {
    if (res.statusCode === 200) {
      let managers: SelectValueType[] = []
      res?.data?.map((obj: any) => {
        // Only include users who can be reporting managers (you might want to add additional filtering)
        managers.push({
          label: `${obj?.firstName ?? ''} ${obj?.lastName ?? ''}`.trim(),
          value: obj?.id,
        })
      })
      setManagers(managers)
    }
  })
}

export const getHRData = (setHRUsers: Function) => {
  getActiveUsers().then((res: APIResponse) => {
    if (res.statusCode === 200) {
      let hrUsers: SelectValueType[] = []
      res?.data?.map((obj: any) => {
        // Only include users who can be HR (you might want to add additional filtering)
        hrUsers.push({
          label: `${obj?.firstName ?? ''} ${obj?.lastName ?? ''}`.trim(),
          value: obj?.id,
        })
      })
      setHRUsers(hrUsers)
    }
  })
}

export const handleInputChange = (
  event: React.SyntheticEvent,
  setFormField: Function,
  InputError: InputErrorType,
  setInputError: Function
) => {
  let target = event.target as HTMLInputElement
  setFormField((prev: any) => ({
    ...prev,
    [target.name]: target.type === 'checkbox' ? target.checked : target.value,
  }))
  clearInputError(target.name, InputError, setInputError)
}

//to handle select, radio input field value change
export const handleOtherInputChange = (
  value: string | null | number | '' | string[] | File,
  inputName: string,
  setFormField: Function,
  InputError: InputErrorType,
  setInputError: Function
) => {
  clearInputError(inputName, InputError, setInputError)
  setFormField((prev: any) => ({
    ...prev,
    [inputName]: value,
  }))
}

export const getFilterLengthData = (url: string) => {
  let storageData: any = sessionStorage.getItem('filterLength')
  const pattern = /[!@#$%^&*()_{}\[\]:;<>,.?~\\/\-=|]/g
  let filterDataLength: number | null = null
  let key = url.replaceAll(pattern, '')
  if (storageData) {
    storageData = JSON.parse(storageData)
    filterDataLength = isNaN(Number(storageData[key])) ? 10 : Number(storageData[key])
  } else {
    filterDataLength = 10
  }
  return { filterDataLength }
}

export const deleteRecord = (
  url: string,
  setData: Function,
  setFormField: Function,
  setEditId: Function,
  setInputError: Function,
  formFieldInitialState: any,
  setShowForm?: Function,
  otherUrl?: string
) => {
  cancelSubmit(setFormField, setEditId, setInputError, formFieldInitialState, setShowForm)
  const { token, tenantId } = setupAxios()
  Swal.fire({ ...AlertProps, icon: 'warning', title: DELETE_MESSAGE }).then(
    (result: SweetAlertResult) => {
      if (result.isConfirmed) {
        api.delete(`/${url}`, token, tenantId, true).then((res: APIResponse) => {
          if (res.statusCode === 202) {
            getRecords(otherUrl ? otherUrl : url.split('/')[0], setData)
          }
        })
      }
    }
  )
}

export const getRecords = (url: string, setData: Function) => {
  setData((prev: CommonApiDataType) => ({ ...prev, loading: true }))
  const { token, tenantId } = setupAxios()
  let otherQuery = url.includes('?')
  const { filterDataLength } = getFilterLengthData(otherQuery ? url.split('?')[0] : url)

  api
    .get(
      `/${url}${otherQuery ? `&` : '?'}limit=${Number(filterDataLength) ?? null}`,
      token,
      tenantId,
      false
    )
    .then((res: APIResponse) => {
      if (res && res.statusCode === 200) {
        setTimeout(() => {
          setData((prev: CommonApiDataType) => ({
            ...prev,
            loading: false,
            error: null,
            data: res?.data?.result ?? res?.data,
            queryData: res?.data?.queryParams ?? null,
          }))
        }, 150)
      } else if (res) {
        setData((prev: CommonApiDataType) => ({
          ...prev,
          loading: false,
          error: res.message || 'API call failed',
          data: res.data?.result,
          queryData: res?.data?.queryParams ?? null,
        }))
      } else {
        console.error('Debug - API call returned undefined/null response');
        setData((prev: CommonApiDataType) => ({
          ...prev,
          loading: false,
          error: 'API call failed - no response received',
          data: null,
          queryData: null,
        }))
      }
    })
    .catch((error) => {
      console.error('Debug - API call error:', error);
      setData((prev: CommonApiDataType) => ({
        ...prev,
        loading: false,
        error: 'Network error or API call failed',
        data: null,
        queryData: null,
      }))
    })
}

//to add/update record for a given master
export const handleSubmit = (
  url: string,
  formField: any,
  formFieldInitialState: any,
  setData: Function,
  setEditId: Function,
  setFormField: Function,
  editId: string | null,
  setInputError: Function,
  validateForm: Function,
  setSubmitAPIStatus: Function,
  addRecord: Function,
  updateRecord: Function,
  setShowForm?: Function
) => {
  let { cnt, error } = validateForm(formField)
  setInputError(error)
  if (cnt === 0) {
    if (editId === null) {
      setSubmitAPIStatus((prev: SubmitAPIStatusType) => ({ ...prev, loading: true }))
      addRecord(formField).then((res: APIResponse) => {
        if (res.statusCode === 201 || res?.statusCode === 200) {
          getRecords(url, setData)
          cancelSubmit(setFormField, setEditId, setInputError, formFieldInitialState, setShowForm)
        } else {
          // Handle API errors properly to prevent uncaught errors
          console.error('API Error:', res)
          if (res.message) {
            Message(res.message, 'error')
          }
        }
        setSubmitAPIStatus((prev: SubmitAPIStatusType) => ({ ...prev, loading: false }))
      }).catch((error) => {
        // Handle uncaught promise rejections
        console.error('Uncaught error in handleSubmit:', error)
        Message('An unexpected error occurred. Please try again.', 'error')
        setSubmitAPIStatus((prev: SubmitAPIStatusType) => ({ ...prev, loading: false }))
      })
    } else {
      Swal.fire({ ...AlertProps, icon: 'warning', title: UPDATE_MESSAGE }).then(
        (result: SweetAlertResult) => {
          if (result.isConfirmed) {
            setSubmitAPIStatus((prev: SubmitAPIStatusType) => ({ ...prev, loading: true }))
            updateRecord(formField, editId).then((res: APIResponse) => {
              if (res.statusCode === 200) {
                getRecords(url, setData)
                cancelSubmit(
                  setFormField,
                  setEditId,
                  setInputError,
                  formFieldInitialState,
                  setShowForm
                )
              } else {
                // Handle API errors properly to prevent uncaught errors
                console.error('API Error:', res)
                if (res.message) {
                  Message(res.message, 'error')
                }
              }
              setSubmitAPIStatus((prev: SubmitAPIStatusType) => ({ ...prev, loading: false }))
            }).catch((error) => {
              // Handle uncaught promise rejections
              console.error('Uncaught error in handleSubmit:', error)
              Message('An unexpected error occurred. Please try again.', 'error')
              setSubmitAPIStatus((prev: SubmitAPIStatusType) => ({ ...prev, loading: false }))
            })
          }
        }
      )
    }
  }
}

//to reset form and its error message
export const cancelSubmit = (
  setFormField: Function,
  setEditId: Function,
  setInputError: Function,
  formFieldInitialState: any,
  setShowForm?: Function
) => {
  setEditId(null)
  if (setShowForm) setShowForm(false)
  setFormField(formFieldInitialState)
  setInputError({})
}
